import { Section } from "../ui/Section";
import { Eyebrow } from "../ui/Eyebrow";
import { H2, Highlight } from "../ui/Heading";
import { HexButton } from "../ui/HexButton";
import { ENTERPRISE_FEATURES, PRO_FEATURES } from "../data/pricing";
import { LINKS } from "../data/links";
import { PricingTier } from "./PricingTier";

export function Pricing() {
  return (
    <Section id="pricing">
      <Eyebrow n="08">Pricing</Eyebrow>
      <H2>
        Plain pricing. <Highlight>Bring your own key</Highlight>.
      </H2>
      <div className="mt-14 grid grid-cols-2 gap-6 items-stretch max-md:grid-cols-1 max-md:gap-9">
        <PricingTier
          accent
          label="INDIVIDUAL"
          price="$49.99"
          priceSuffix="/seat / month"
          description="Your bill, your provider, your data."
          features={PRO_FEATURES}
          cta={
            <HexButton variant="primary" size="lg" href={LINKS.setup}>
              Book a setup call
            </HexButton>
          }
        />
        <PricingTier
          label="ENTERPRISE"
          price="Custom"
          priceClassName="text-[56px]"
          description="For teams of 10+ who close in chat."
          features={ENTERPRISE_FEATURES}
          cta={
            <HexButton variant="secondary" size="lg" href={LINKS.contact}>
              Talk to us →
            </HexButton>
          }
        />
      </div>
    </Section>
  );
}
